import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceLineMetric, ServiceLineMetricQuery } from '@shared/models/service-line-metric.model';
import { HttpClient } from '@angular/common/http';
import { EvaluateData } from '@shared/models/service-line-routing.model';
import { environment } from '@env/environment';
import { PlatformService } from '@core/services/platform.service';
import { AuthorizationCaseMetric } from '@products/dmepos/models/authorization-case-metric.model';
import { LazyLoadEvent } from 'primeng/api';
import { ODataService } from '@mynexus/mynexus-ui-lib';
import { cloneDeep } from 'lodash-es';

@Injectable()
export abstract class MetricsBaseService {
  protected readonly API_URL = `${environment.api.RR}/api`;
  protected productName

  abstract uniqueKey: string;

  constructor(
    protected readonly platformService: PlatformService,
    protected readonly http: HttpClient,
    protected readonly oDataService: ODataService,
  ) {
    this.productName = this.platformService.currentProduct;
  }

  abstract query(query: string): Observable<ServiceLineMetricQuery>;

  abstract getEvaluateQueue(metric: ServiceLineMetric | AuthorizationCaseMetric): Observable<EvaluateData>;

  prepareQuery(rawQuery: LazyLoadEvent): string {
    const query = cloneDeep(rawQuery);
    const { filters } = query;

    // FE converts null to 'New' label on FE for better UX (successfully routed only)
    // We need to convert it back to null when we're sending query to BE
    if (filters && 'priorUserName' in filters) {
      const { priorUserName, isRouted } = filters;

      if (priorUserName.value.toLowerCase() === 'new' && isRouted?.value !== false) {
        filters['priorUserName'].matchMode = 'eq';
        filters['priorUserName'].value = 'null';

        filters['isRouted'] = {
          matchMode: 'eq',
          value: true,
        };
      }
    }

    return this.oDataService.buildQuery(query);
  }
}
